import { useEffect, useState } from "react";
import SiteHeader from "@/components/SiteHeader";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import EditorialMarquee from "@/components/EditorialMarquee";
import Manifesto from "@/components/Manifesto";
import ServiceAreas from "@/components/ServiceAreas";
import ContactSection from "@/components/ContactSection";
import SiteFooter from "@/components/SiteFooter";
import { DEFAULT_GALLERY, DEFAULT_SITE } from "@/data/siteData";
import { apiRequest } from "@/lib/api";

export default function HomePage() {
  const [site, setSite] = useState(DEFAULT_SITE);
  const [gallery, setGallery] = useState(DEFAULT_GALLERY);
  const [lang, setLang] = useState(() => new URLSearchParams(window.location.search).get("lang") === "es" ? "es" : window.localStorage.getItem("glow_lang") || "en");
  useEffect(() => {
    apiRequest("/site-content").then((data) => { setSite(data.content); setGallery(data.gallery); }).catch(() => {});
  }, []);
  useEffect(() => {
    window.localStorage.setItem("glow_lang", lang);
    document.documentElement.lang = lang;
    document.title = lang === "en" ? "Glow Cleaning Co. | Baltimore & Maryland" : "Limpieza Glow Co. | Baltimore y Maryland";
    const url = new URL(window.location.href);
    url.searchParams.set("lang", lang);
    window.history.replaceState({}, "", url);
  }, [lang]);
  return <div className="site-page"><SiteHeader lang={lang} setLang={setLang} phone={site.phone} /><main><Hero site={site} lang={lang} /><EditorialMarquee lang={lang} /><Services lang={lang} /><Manifesto lang={lang} gallery={gallery} /><ServiceAreas lang={lang} /><ContactSection site={site} lang={lang} /></main><SiteFooter site={site} lang={lang} /></div>;
}
